import Loader from '@/UI/Loader';

/** Content-area fallback while a lazy route chunk loads inside the app shell. */
export const PageContentFallback = () => (
  <Loader centered size="large" minHeight="40vh" />
);

/** Full-viewport fallback for top-level lazy entry routes (embed, plugins). */
export const PageFallback = () => (
  <Loader centered size="large" minHeight="100vh" />
);
